// src/features/editor/components/studio/EditorShell.tsx
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { messagesNow } from '@/i18n'
import { messages } from './messages'
import { ModerationPoller } from '@/features/moderation/ModerationPoller'
import { EditorLoadGate } from './EditorLoadGate'
import { EditorWorkspace } from './EditorWorkspace'
import { useEditorCourseGate } from './useEditorCourseGate'
import { useReadSourceRemap } from './useReadSourceRemap'

interface Props {
  courseId: number
}

export const EditorShell = ({ courseId }: Props) => {
  // Редактор ждёт СВЕЖЕГО ответа `/moderation` и курса из названного им источника
  // (`useEditorCourseGate`). Поллер поэтому стоит над загрузкой курса и ВСЕГДА на
  // одной позиции в дереве: смена ветки гейт ⇄ редактор его не перемонтирует.
  const { course, draftOfId, courseMissing, loadFailed, retry } = useEditorCourseGate(courseId)
  const navigate = useNavigate()
  // Сменился источник чтения (черновик ⇄ живой) — выделение переезжает на те же
  // уроки и блоки под их новыми id.
  useReadSourceRemap(course)

  // Открыт id черновика (старая ссылка): редактор ключуется живым id.
  useEffect(() => {
    if (draftOfId) navigate(`/editor/${draftOfId}`, { replace: true })
  }, [draftOfId, navigate])

  useEffect(() => {
    if (courseMissing) {
      toast.error(messagesNow(messages).courseNotFound)
      navigate('/dashboard', { replace: true })
    }
  }, [courseMissing, navigate])

  return (
    <>
      {course !== undefined && !draftOfId ? (
        <EditorWorkspace course={course} />
      ) : (
        <EditorLoadGate isError={loadFailed} onRetry={retry} />
      )}
      <ModerationPoller courseId={courseId} />
    </>
  )
}
